import { render, staticRenderFns } from "./DimissioniProtetteEdit.vue?vue&type=template&id=10283640"
import script from "./DimissioniProtetteEdit.vue?vue&type=script&lang=js"
export * from "./DimissioniProtetteEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports